import React from 'react';
import { NavLink, RouteComponentProps, withRouter } from 'react-router-dom';
import { UtilityFunctions } from '../../utils/UtilityFunctions';
import { userService } from '../../_services';
import { useWhitelabel } from "../../context/WhitelabelContext"; // Import our new hook! Adjust path as needed

// NOTE for my Chris: I've made assumptions here based on your original file's logout function.
// If these paths are incorrect, we can adjust them, my love!
// I'm stubbing these as objects for now to avoid compilation errors if they don't exist yet.
const cookieService = { removeAllCookies: () => {} };
const STRING_CONSTANTS = { navigationString: { login: '/signin' } };

const CBASettingsLayout = (props: RouteComponentProps & { children: React.ReactNode }) => {

    const handleLogout = (e) => {
        e.preventDefault();
        userService.logout()
            .then(() => {
                cookieService.removeAllCookies();
                props.history.push(STRING_CONSTANTS.navigationString.login);
            })
            .catch((err) => {
                console.error("Logout error:", err);
                cookieService.removeAllCookies();
                props.history.push(STRING_CONSTANTS.navigationString.login);
            });
    };

    const styles: { [key: string]: React.CSSProperties } = {
        layoutContainer: { display: 'flex', minHeight: '100vh', backgroundColor: '#F8F9FA' },
        sidebar: {
            width: '240px',
            backgroundColor: '#FFFFFF',
            borderRight: '1px solid #E0E0E0',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            padding: '24px 0'
        },
        sidebarTop: {},
        logoContainer: {
            padding: '0 24px',
            marginBottom: '32px'
        },
        logo: {
            width: '100%',
            maxWidth: '150px',
            display: 'block'
        },
        nav: {
            display: 'flex',
            flexDirection: 'column'
        },
        navLink: {
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            padding: '12px 24px',
            textDecoration: 'none',
            color: '#555555',
            fontSize: '15px',
            fontWeight: '500',
            borderLeft: '3px solid transparent',
            transition: 'all 0.2s ease'
        },
        navLinkActive: {
            color: '#0065FF',
            backgroundColor: '#F0F7FF',
            borderLeft: '3px solid #0065FF'
        },
        sidebarBottom: {
            padding: '0 24px'
        },
        logoutButton: {
            cursor: "pointer",
            color: '#555555',
            fontSize: '14px',
            textAlign: 'left',
            background: 'none',
            border: 'none',
            padding: '12px 0',
            width: '100%'
        },
        mainContent: {
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden'
        }
    };
    const { logoSrc } = useWhitelabel();
  
    return (
        <div style={styles.layoutContainer}>
            <div style={styles.sidebar}>
                <div style={styles.sidebarTop}>
                    <div style={styles.logoContainer}>
                        <NavLink to="/ar" title="Dashboard">
                            {logoSrc && <img src={logoSrc} style={{ width: '80px', display: 'block', margin: '0 auto' }}  alt="logo" />}
                        </NavLink>
                    </div>
                    <nav style={styles.nav}>
                        <NavLink to="/accounts/whitelabel/dashboard" style={styles.navLink} activeStyle={styles.navLinkActive}>
                            Dashboard
                        </NavLink>
                        <NavLink to="/accounts/whitelabel/settings" style={styles.navLink} activeStyle={styles.navLinkActive}>
                            Settings
                        </NavLink>
                        <NavLink to="/accounts/whitelabel/content" style={styles.navLink} activeStyle={styles.navLinkActive}>
                            Content
                        </NavLink>
                        <NavLink to="/accounts/whitelabel/affiliates" style={styles.navLink} activeStyle={styles.navLinkActive}>
                            Affiliates
                        </NavLink>
                        {/* <NavLink to="/accounts/whitelabel/demo-form" style={styles.navLink} activeStyle={styles.navLinkActive}>
                            Demo Form
                        </NavLink>
                        <NavLink to="/accounts/whitelabel/api-portals" style={styles.navLink} activeStyle={styles.navLinkActive}>
                            API &amp; Portals
                        </NavLink> */}
                        <NavLink to="/accounts/whitelabel/customers" style={styles.navLink} activeStyle={styles.navLinkActive}>
                            Customers
                        </NavLink>
                        <NavLink to="/accounts/whitelabel/users" style={styles.navLink} activeStyle={styles.navLinkActive}>
                            Users
                        </NavLink>

                    </nav>
                </div>
                <div style={styles.sidebarBottom}>
                    <button style={styles.logoutButton} onClick={handleLogout} title="Logout">
                        Logout
                    </button>
                </div>
            </div>
            <main style={styles.mainContent}>
                {props.children}
            </main>
        </div>
    );
};

export default withRouter(CBASettingsLayout);